import { MarketplaceProduct, StargateCloudProduct } from './stargate.types';
const marketplaceStargateProductMapping = Object.freeze({
  [MarketplaceProduct.JIRA]: [StargateCloudProduct.JIRA_CORE, StargateCloudProduct.JIRA_SERVICE_DESK, StargateCloudProduct.JIRA_SOFTWARE],
  [MarketplaceProduct.CONFLUENCE]: [StargateCloudProduct.CONFLUENCE],
  [MarketplaceProduct.COMPASS]: [StargateCloudProduct.COMPASS]
});
const toMarketplaceProduct = stargateProduct => {
  const marketplaceProducts = Object.keys(marketplaceStargateProductMapping);
  return marketplaceProducts.find(product => marketplaceStargateProductMapping[product].includes(stargateProduct));
};
export const toStargateProducts = marketplaceProducts => marketplaceProducts.flatMap(product => marketplaceStargateProductMapping[product]).filter(product => !!product);
export const isCompatibleMarketplaceProduct = marketplaceProduct => marketplaceProduct === 'jira' || marketplaceProduct === 'confluence' || marketplaceProduct === 'compass';
export const toMarketplaceProducts = stargateProducts => {
  const marketplaceProducts = new Set();
  stargateProducts.forEach(stargateProduct => {
    const marketplaceProduct = toMarketplaceProduct(stargateProduct);
    if (marketplaceProduct) {
      marketplaceProducts.add(marketplaceProduct);
    }
  });
  return [...marketplaceProducts];
};